import React from 'react';
import Card from '../../../components/Card';
import SemesterLayout from '../../../components/SemesterLayout';

const Sem7 = ({ branch = "CSE" }) => {
  const notes = [
    { title: 'Data Warehousing and Data Mining', link: `/notes/${branch.toLowerCase()}/DWDM` },
    { title: 'Machine Learning', link: `/notes/${branch.toLowerCase()}/ML_CSE` },
    { title: 'Next Generation Web', link: `/notes/${branch.toLowerCase()}/NGW` },
    { title: 'Principles of Entrepreneurship Mindset', link: `/notes/${branch.toLowerCase()}/PEM` },
    { title: 'Pattern Recognition and Computer Vision', link: `/notes/${branch.toLowerCase()}/PRCV` },
    { title: 'Reinforcement Learning and Deep Learning', link: `/notes/${branch.toLowerCase()}/RLDL` },
  ];

  return (
    <SemesterLayout
      branch={branch}
      semester="7th Semester"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {notes.map((note, index) => (
          <Card key={index} title={note.title} link={note.link} />
        ))}
      </div>
    </SemesterLayout>
  );
};

export default Sem7;